import { mapGetters } from 'vuex'
import { LIBRARY_TYPE } from '@/constants/libraryType'

export const BrowzwearPlugin = {
  computed: {
    ...mapGetters({
      browzwearAPI: 'getBrowzwearAPI',
      pluginUser: 'getCognitoUserData'
    })
  },

  watch: {
    /**
     * @param {boolean} newUser
     */
    pluginUser (newUser) {
      if (newUser) {
        this.sendUserInfoToPlugin()
      }
    }
  },

  methods: {
    /**
     * Sends user data to browzwearAPI. Expects to be called only when there is a valid user
     * To test this on localhost:8080 you MUST comment the development environment exception on  main.js redirectToLogin() function
     * and also change COGNITO variables to actually make the login with a valid email.
     */
    sendUserInfoToPlugin () {
      if (!this.browzwearAPI) {
        return
      }

      const message = {
        action: 'login',
        data: this.pluginUser,
        cookie: document.cookie,
        version: 1
      }
      this.browzwearAPI.sendMessage(message)
    },

    /**
     * Sends 3D information to BW API. Blocks require a special action and file
     *
     * @param   {object} item
     * @param   {number} index
     *
     * @returns {object}
     */
    sendDataToBrowzwear (item, index = 0) {
      let actionType
      let assetUrl

      if (item.libraryType === LIBRARY_TYPE.BLOCK) {
        actionType = 'open_garment'
        assetUrl = item.main_model
      } else {
        actionType = 'download_asset'
        assetUrl = item.filesDict.u3ma[index]?.assets_url || null
      }

      if (!assetUrl) {
        return
      }

      const message = {
        action: actionType,
        data: {
          asset_type: item.libraryType,
          asset_id: item.id,
          // TODO: This needs to change in the future, because it is not just for .U3MA for some time
          // but because it is difficult to change the old plugin, we are a bit stuck with this.
          asset_U3MA_url: assetUrl
        },
        cookie: document.cookie,
        version: 1
      }

      return this.browzwearAPI.sendMessage(message)
    },

    /**
     * Sends the new endpoint URL to the plugin
     *
     * @param   {string} newUrl
     *
     * @returns {object}
     */
    sendURLChangeToPlugin (newUrl) {
      if (!this.browzwearAPI) {
        return
      }

      const message = {
        action: 'update_fe_url',
        data: {
          url: newUrl
        },
        version: 1
      }

      return this.browzwearAPI.sendMessage(message)
    }
  }
}
